'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Download, FileText, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getResizedPictureUrl, getLocalizedValue } from '@/lib/utils';
import { CatalogueType } from '@/types/catalogue';
import { useFileDownload } from '@/hooks';
import { LazyImage, NoImagePlaceholder } from '@/components/partials/index';
type PropsType = {
  catalogue: CatalogueType;
  locale: string;
};
const CatalogueItem = t0 => {
  const $ = _c(34);
  const {
    catalogue,
    locale
  } = t0;
  const t = useTranslations();
  const {
    mutate: downloadFile,
    isPending
  } = useFileDownload();
  let t1;
  if ($[0] !== catalogue || $[1] !== locale) {
    t1 = getLocalizedValue(catalogue, "title", locale);
    $[0] = catalogue;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const title = t1;
  let t2;
  if ($[3] !== catalogue || $[4] !== locale) {
    t2 = getLocalizedValue(catalogue, "content", locale);
    $[3] = catalogue;
    $[4] = locale;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const content = t2;
  const hasPicture = !!catalogue.picture;
  let t3;
  if ($[6] !== catalogue.file || $[7] !== downloadFile) {
    t3 = () => {
      if (!catalogue.file) {
        return;
      }
      downloadFile({
        fileId: catalogue.file.id,
        fileName: catalogue.file.name
      });
    };
    $[6] = catalogue.file;
    $[7] = downloadFile;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleDownload = t3;
  let t4;
  if ($[9] !== catalogue.picture || $[10] !== hasPicture || $[11] !== title) {
    t4 = <div className="bg-muted/30 flex h-50 items-center justify-center p-8">{hasPicture ? <LazyImage src={getResizedPictureUrl(catalogue.picture.path, 400, 400)} alt={title} width={200} height={200} className="h-full w-full object-contain" /> : <NoImagePlaceholder icon={FileText} />}</div>;
    $[9] = catalogue.picture;
    $[10] = hasPicture;
    $[11] = title;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== title) {
    t5 = <h3 className="text-foreground line-clamp-2 text-lg font-semibold">{title}</h3>;
    $[13] = title;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== content) {
    t6 = content && content !== "-" && <div className="html-content text-muted line-clamp-3 max-w-none text-sm" dangerouslySetInnerHTML={{
      __html: content
    }} />;
    $[15] = content;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div className="flex-1 space-y-3">{t5}{t6}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== isPending || $[21] !== t) {
    t8 = isPending ? <>{t("downloading")}<Loader2 className="h-5 w-5 animate-spin" /></> : <>{t("download")}<Download className="h-5 w-5" /></>;
    $[20] = isPending;
    $[21] = t;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== handleDownload || $[24] !== isPending || $[25] !== t8) {
    t9 = <Button onClick={handleDownload} disabled={isPending} size="default" variant="brand" className="flex w-full flex-row justify-between uppercase">{t8}</Button>;
    $[23] = handleDownload;
    $[24] = isPending;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t7 || $[28] !== t9) {
    t10 = <div className="flex flex-1 flex-col gap-4 p-6">{t7}{t9}</div>;
    $[27] = t7;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="bg-brand absolute bottom-0 left-0 h-1 w-0 transition-all duration-300 group-hover:w-full" />;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t10 || $[32] !== t4) {
    t12 = <div className="group bg-card relative flex flex-col overflow-hidden rounded-lg border shadow-sm transition-all hover:shadow-lg">{t4}{t10}{t11}</div>;
    $[31] = t10;
    $[32] = t4;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};
export default CatalogueItem;